
import { isEmpty, throttle, debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'FixTab',
  props: {
    tabContent: {
      type: Array,
      default: () => [],
      required: true
    },
    fixDis: {
      type: Number,
      default: 0
    },
    extendClass: {
      type: String,
      default: ''
    },
    offset: {
      type: Number,
      default: 175
    }
  },
  data() {
    return {
      showIndex: 0,
      scroll: null,
      isClickTriggeredScroll: false,
      tipHeight: 0,
      resizeObserver: null
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    isShowTabs() {
      return !isEmpty(this.tabContent)
    },
    styleObj() {
      return {
        top: `${this.fixDis + this.tipHeight + (this.$store.state.islangsw ? 48 : 0)}px`
      }
    }
  },
  watch: {
    tipHeight() {
      this.scroll?.destroy()
      const SmoothScroll = require('smooth-scroll')
      this.scroll = new SmoothScroll(`[data-x-id]`, {
        speed: 10,
        offset: this.offset + this.tipHeight + (this.$store.state.islangsw ? 48 : 0)
      })
    }
  },
  mounted() {
    if (!this.scroll) {
      const SmoothScroll = require('smooth-scroll')
      this.scroll = new SmoothScroll(`[data-x-id]`, {
        speed: 10,
        offset: this.offset + this.tipHeight + (this.$store.state.islangsw ? 48 : 0)
      })
    }
    this.scrollEvent = throttle(this.scrollEvent, 10)
    document.addEventListener('scroll', this.scrollEvent, false)
    this.observeDomHeight()
  },
  beforeDestroy() {
    this.scroll?.destroy()
    document.removeEventListener('scroll', this.scrollEvent, false)
    this.resizeObserver.disconnect()
  },
  methods: {
    gethei () {
      if (!this.scroll) {
        const SmoothScroll = require('smooth-scroll')
        this.scroll = new SmoothScroll(`[data-x-id]`, {
          speed: 10,
          offset: this.offset + this.tipHeight + (this.$store.state.islangsw ? 48 : 0)
        })
      }
      this.scrollEvent = throttle(this.scrollEvent, 10)
      document.addEventListener('scroll', this.scrollEvent, false)
      this.observeDomHeight()
    },
    scrollToSection(item, index) {
      console.log(item, 999, index)
      this.isClickTriggeredScroll = true
      this.showIndex = index
      if (process.client) {
        this.scroll?.cancelScroll()
        const element = document.querySelector(`[data-x-id=${item.dataId}]`)
        if (element) {
          setTimeout(() => {
            this.scroll?.animateScroll(element)
            this.seeEle(index)
          }, 100)
          // this.checkAndScrollTabContainer(index);
        } else {
          console.log('没有找到任何元素');
        }
      }
      this.changeStatus()

      // 检查并可能滚动标签容器
      this.checkAndScrollTabContainer(index);
    },
    scrollToSectionByid(id) {
      console.log('scrollToSectionByid')
      const item = this.tabContent?.find((it, k) => {
        return it.dataId.trim() == id
      })
      if(!item){
        return false
      }
      const index = this.tabContent?.indexOf(item)
      this.scrollToSection(item, index)
    },
    changeStatus: debounce(function() {
      // console.log('触发')
      this.isClickTriggeredScroll = false
    }, 1000),
    scrollEvent() {
      if (this.isClickTriggeredScroll) return
      this.scroll?.cancelScroll()
      // 滑动的时候让选项选中
      const elements = document.querySelectorAll(`[data-x-id]`)
      if (!isEmpty(elements)) {
        for (let i = 0; i <= elements.length -1; i++) {
          const rect = elements[i].getBoundingClientRect()
          // 45是自身的高度 30 滑动的space
          // if (i == 1) console.log(rect.top, i, this.offset, 9997, rect.top >=0, rect.top<=  this.offset)
          if (rect.top >=0 &&  (rect.top - 50) <=  this.offset) {
            // console.log('rect.top',i, elements[i], rect.top, this.offset, this.tipHeight + (this.$store.state.islangsw ? 48 : 0) + 45 + 30, this.offset +
            //   this.tipHeight + (this.$store.state.islangsw ? 48 : 0) + 45 + 30)
            // console.log(i, 77567, elements.length, 888, this.isScrollAtBottom())
            this.showIndex = i
            this.seeEle(i)
          }
          // console.log(888, this.isScrollAtBottom())
          if (this.isScrollAtBottom()) {
            this.showIndex = elements.length -1
            this.seeEle(elements.length -1)
          }
          if (i === 0) {
            if (Math.abs(rect.top) < 300) {
              this.showIndex = 0
              this.seeEle(0)
            }
          }
          // const isInViewport = rect.top >= 0 && rect.bottom <=
          //   (window.innerHeight || document.documentElement.clientHeight);
          // if (isInViewport) {
          //   this.showIndex = i;
          //   this.seeEle(i);
          // }
        }
      }
    },
    seeEle(i) {
      if (this.tabContent[i]?.dataId) {
        // 滚动的时候tab 会自动出现在当前视口
        // 获取所有 Tabs 的容器
        const container = this.$el.querySelector('.fix-tab-content');
        if (!container) return;

        // 获取当前激活的 Tab 元素
        const activeTab = container.children[i];
        if (!activeTab) return;

        // 计算容器和当前激活 Tab 的左边界
        const containerScrollLeft = container.offsetLeft;
        const activeTabOffsetLeft = activeTab.offsetLeft;

        // 计算容器可视宽度和 Tab 宽度
        const containerVisibleWidth = container.clientWidth;
        const activeTabWidth = activeTab.clientWidth;

        // 检查当前激活的 Tab 是否已经在可视区域内
        // console.log(containerVisibleWidth, 111, containerScrollLeft, 222, activeTabWidth, 333, activeTabOffsetLeft, 444, activeTabOffsetLeft - containerScrollLeft + activeTabWidth - containerVisibleWidth / 2, 555, activeTabOffsetLeft - containerVisibleWidth / 2)
        if (containerVisibleWidth / 2 < activeTabOffsetLeft - containerScrollLeft) {
          container.scrollTo({
            left: activeTabOffsetLeft - containerScrollLeft + activeTabWidth - containerVisibleWidth / 2,
            behavior: 'smooth'
          });
        } else {
          container.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }
        // setTimeout(() => {
        //   console.log(container.scrollLeft, 99987)
        // }, 1000)
        // if (activeTabOffsetLeft < containerScrollLeft ||
        //   activeTabOffsetLeft + activeTabWidth > containerScrollLeft + containerVisibleWidth) {
        //   // 将当前激活的 Tab 滚动到容器的中央
        //   console.log(activeTabOffsetLeft - (containerVisibleWidth / 2 - activeTabWidth / 2), 7756)
        //   container.scrollTo({
        //     left: activeTabOffsetLeft - (containerVisibleWidth / 2 - activeTabWidth / 2),
        //     behavior: 'smooth'
        //   });
        // }
      }
    },
    isScrollAtBottom() {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 获取当前滚动条的位置
        const windowHeight = window.innerHeight; // 浏览器视口的高度
        const documentHeight = document.documentElement.scrollHeight; // 文档的总高度
    
        return scrollTop + windowHeight >= documentHeight; // 当滚动条位置加上窗口高度大于等于文档高度时，表明到达了底部
    },
    checkAndScrollTabContainer(index) {
      // const container = this.$el.querySelector('.fix-tab-content');
      // if (!container) return;

      // const tabs = container.children;
      // if (index < 0 || index >= tabs.length) return;

      // const currentTab = tabs[index];

      // // 获取当前标签和容器的相关尺寸和位置信息
      // const tabRect = currentTab.getBoundingClientRect();
      // const containerRect = container.getBoundingClientRect();

      // // 判断是否需要向左或向右滚动
      // if (tabRect.left < containerRect.left + 30) {
      //   // 当前标签在视图左边界之外，向左滚动
      //   container.scrollLeft -= tabRect.width;
      // } else if (tabRect.right > containerRect.right - 30) {
      //   // 当前标签在视图右边界之外，向右滚动
      //   container.scrollLeft += tabRect.width;
      // }
    },
    observeDomHeight() {
      const currentDom = document.getElementById('head-tips')
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const rect = entry.contentRect
          this.tipHeight = rect.height || 0
        }
      })
      this.resizeObserver.observe(currentDom)
    }
  }
}
